import { createContext } from 'react';

const ProfileContext = createContext({});

export const ProfileProvider = ProfileContext.Provider;

export default ProfileContext;
